/* ==========================================================================
   Comportements du theme maison (prefixe pl-).
   Chaque bloc ne s'active que si son element est present dans la page.
   Sans JavaScript, tout reste utilisable : liens, formulaires, details.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Bandeau d'annonce tournant
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-pl-announce]').forEach(function (bandeau) {
    var items = bandeau.querySelectorAll('.pl-announce__item');
    if (items.length < 2) { return; }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    var i = 0;
    var delai = (parseInt(bandeau.getAttribute('data-interval'), 10) || 5) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, delai);
  });

  /* ------------------------------------------------------------------
     En-tete : menu telephone et recherche
     ------------------------------------------------------------------ */
  var burger = document.querySelector('[data-pl-burger]');
  var tiroir = document.querySelector('[data-pl-drawer-nav]');
  if (burger && tiroir) {
    burger.addEventListener('click', function () {
      var ouvert = tiroir.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    });
  }

  /* Deux loupes : a gauche sur telephone, a droite sur ordinateur */
  var loupes = document.querySelectorAll('[data-pl-search-toggle]');
  var recherche = document.getElementById('pl-search');
  if (recherche) {
    loupes.forEach(function (loupe) {
      loupe.addEventListener('click', function () {
        var ouvrir = recherche.hasAttribute('hidden');
        recherche.toggleAttribute('hidden', !ouvrir);
        loupes.forEach(function (l) { l.setAttribute('aria-expanded', ouvrir ? 'true' : 'false'); });
        if (ouvrir) { recherche.querySelector('input[type="search"]').focus(); }
      });
    });
  }

  /* ------------------------------------------------------------------
     En-tete transparent de l'accueil : plein des qu'on quitte le haut de
     la photo, ou qu'un menu, la recherche ou le tiroir est ouvert.
     Horizon fait defiler .page-wrapper : on ecoute le defilement de toute
     la page (capture), quel que soit l'element qui defile.
     ------------------------------------------------------------------ */
  var entete = document.querySelector('.pl-header--overlay');
  if (entete) {
    var zone = document.querySelector('.page-wrapper');
    var hero = document.querySelector('.pl-hero');
    var majEntete = function () {
      var y = Math.max(zone ? zone.scrollTop : 0, window.scrollY || 0);
      var limite = hero ? Math.max(hero.offsetHeight - entete.offsetHeight - 40, 40) : 40;
      var ouvert = entete.querySelector('.pl-has-mega:hover, .pl-has-mega:focus-within') ||
        !document.getElementById('pl-search').hasAttribute('hidden') ||
        entete.querySelector('.pl-drawer-nav.is-open');
      entete.classList.toggle('is-solid', y > limite || !!ouvert);
    };
    document.addEventListener('scroll', majEntete, { passive: true, capture: true });
    entete.addEventListener('mouseover', majEntete);
    entete.addEventListener('mouseleave', function () { setTimeout(majEntete, 50); });
    entete.addEventListener('focusin', majEntete);
    entete.addEventListener('focusout', function () { setTimeout(majEntete, 50); });
    entete.addEventListener('click', function () { setTimeout(majEntete, 0); });
    majEntete();
  }

  /* ------------------------------------------------------------------
     Carrousels : fleches precedent / suivant
     ------------------------------------------------------------------ */
  function brancherRails(racine) {
    racine.querySelectorAll('[data-pl-rail-root]').forEach(function (bloc) {
      var rail = bloc.querySelector('[data-pl-rail]');
      if (!rail || !rail.classList.contains('pl-rail')) { return; }
      var prev = bloc.querySelector('[data-pl-rail-prev]');
      var next = bloc.querySelector('[data-pl-rail-next]');

      function pas() {
        var carte = rail.firstElementChild;
        return carte ? carte.getBoundingClientRect().width + 20 : rail.clientWidth;
      }
      function etat() {
        if (prev) { prev.disabled = rail.scrollLeft <= 2; }
        if (next) { next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2; }
      }
      if (prev) { prev.addEventListener('click', function () { rail.scrollBy({ left: -pas(), behavior: 'smooth' }); }); }
      if (next) { next.addEventListener('click', function () { rail.scrollBy({ left: pas(), behavior: 'smooth' }); }); }
      rail.addEventListener('scroll', etat, { passive: true });
      etat();
    });
  }
  brancherRails(document);

  /* Diapo plein cadre (« About us ») : fondu toutes les 5 s, arret si le
     visiteur demande moins d'animations. */
  document.querySelectorAll('[data-pl-fade]').forEach(function (zone) {
    var images = zone.querySelectorAll('img');
    if (images.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    var i = 0;
    setInterval(function () {
      images[i].classList.remove('is-active');
      i = (i + 1) % images.length;
      images[i].classList.add('is-active');
    }, 5000);
  });

  /* ------------------------------------------------------------------
     Fiche produit
     ------------------------------------------------------------------ */
  var fiche = document.querySelector('[data-pl-product]');
  if (fiche) {
    var principal = fiche.querySelector('[data-pl-gallery-main]');
    var piste = fiche.querySelector('[data-pl-gallery-track]');
    var slides = piste ? Array.prototype.slice.call(piste.querySelectorAll('.pl-gallery__slide')) : [];
    var vignettes = Array.prototype.slice.call(fiche.querySelectorAll('[data-pl-thumb]'));
    var rangee = fiche.querySelector('[data-pl-gallery-thumbs]');

    /* Carrousel : la piste defile (glisser au doigt natif, scroll-snap),
       les fleches et les vignettes la font defiler d'une photo. */
    function marquer(index) {
      slides.forEach(function (sl, i) { sl.classList.toggle('is-active', i === index); });
      vignettes.forEach(function (v, i) { v.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      var v = vignettes[index];
      if (rangee && v) {
        var li = v.parentNode;
        if (rangee.scrollHeight > rangee.clientHeight + 1) {
          rangee.scrollTo({ top: Math.max(0, li.offsetTop - (rangee.clientHeight - li.offsetHeight) / 2), behavior: 'smooth' });
        } else {
          rangee.scrollTo({ left: Math.max(0, li.offsetLeft - (rangee.clientWidth - li.offsetWidth) / 2), behavior: 'smooth' });
        }
      }
    }
    function actuel() {
      return piste && piste.clientWidth ? Math.round(piste.scrollLeft / piste.clientWidth) : 0;
    }
    function montrer(index, instant) {
      if (!slides.length) { return; }
      index = (index + slides.length) % slides.length;
      principal.classList.remove('is-zoomed');
      piste.scrollTo({ left: index * piste.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      marquer(index);
    }
    function montrerMedia(id) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) { montrer(i); return; }
      }
    }

    vignettes.forEach(function (v, i) { v.addEventListener('click', function () { montrer(i); }); });
    var gp = fiche.querySelector('[data-pl-gallery-prev]');
    var gn = fiche.querySelector('[data-pl-gallery-next]');
    if (gp) { gp.addEventListener('click', function () { montrer(actuel() - 1); }); }
    if (gn) { gn.addEventListener('click', function () { montrer(actuel() + 1); }); }
    if (piste) {
      /* photo de la variante choisie au chargement */
      for (var d = 0; d < slides.length; d++) {
        if (slides[d].classList.contains('is-active')) { if (d > 0) { montrer(d, true); } break; }
      }
      var attente = null;
      piste.addEventListener('scroll', function () {
        clearTimeout(attente);
        attente = setTimeout(function () {
          var i = actuel();
          if (slides[i] && !slides[i].classList.contains('is-active')) { principal.classList.remove('is-zoomed'); marquer(i); }
        }, 80);
      }, { passive: true });
      piste.addEventListener('click', function (e) {
        if (e.target.closest('[data-pl-zoom]')) { principal.classList.toggle('is-zoomed'); }
      });
    }

    /* Quantite */
    var qte = fiche.querySelector('input[name="quantity"]');
    fiche.querySelectorAll('[data-pl-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(qte.value, 10) || 1) + parseInt(b.getAttribute('data-pl-qty'), 10);
        qte.value = v < 1 ? 1 : v;
      });
    });

    /* Options -> variante. Les prix viennent du Liquid deja formates
       (filtre money) : aucun montant n'est calcule ici. */
    var donnees = null;
    var source = fiche.querySelector('[data-pl-product-json]');
    try { donnees = source ? JSON.parse(source.textContent) : null; } catch (e) { donnees = null; }

    var champId = fiche.querySelector('[data-pl-variant-id]');
    var prix = fiche.querySelector('[data-pl-price]');
    var prixColle = fiche.querySelector('[data-pl-sticky-price]');
    var stock = fiche.querySelector('[data-pl-stock]');
    var boutons = fiche.querySelectorAll('[data-pl-submit], .pl-sticky-buy .pl-btn');
    var options = Array.prototype.slice.call(fiche.querySelectorAll('[data-pl-option]'));

    function choix() {
      return options.map(function (fs) {
        var menu = fs.querySelector('select');
        if (menu) { return menu.value; }
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function trouver(valeurs) {
      if (!donnees) { return null; }
      for (var i = 0; i < donnees.variants.length; i++) {
        var v = donnees.variants[i];
        var ok = true;
        for (var j = 0; j < valeurs.length; j++) { if (v.options[j] !== valeurs[j]) { ok = false; break; } }
        if (ok) { return v; }
      }
      return null;
    }

    function texte(el, t) { if (el) { el.textContent = t; } }

    function appliquer() {
      var valeurs = choix();
      options.forEach(function (fs, i) { texte(fs.querySelector('[data-pl-option-value]'), valeurs[i] || ''); });
      var v = trouver(valeurs);

      boutons.forEach(function (b) {
        b.disabled = !v || !v.available;
        if (b.hasAttribute('data-pl-submit') || b.closest('.pl-sticky-buy')) {
          b.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : (donnees.unavailable || 'Sold out'));
        }
      });
      if (!v) { return; }

      champId.value = v.id;
      if (prix) {
        prix.innerHTML = '';
        var s = document.createElement('span'); s.textContent = v.price; prix.appendChild(s);
        if (v.compare) { var b = document.createElement('s'); b.textContent = v.compare; prix.appendChild(b); }
      }
      texte(prixColle, v.price);
      texte(fiche.querySelector('[data-pl-tier-price="1"]'), v.price);
      texte(fiche.querySelector('[data-pl-tier-price="2"]'), v.set2);
      texte(fiche.querySelector('[data-pl-tier-price="3"]'), v.set3);
      var principalePaire = fiche.querySelector('[data-pl-pair-main]');
      if (principalePaire) { principalePaire.value = v.id; }

      if (stock) {
        var visible = !v.available || (v.tracked && v.qty > 0);
        stock.hidden = !visible;
        stock.classList.toggle('pl-stock--out', !v.available);
        stock.textContent = v.available ? (donnees.inStock || 'In stock') : (donnees.unavailable || 'Sold out');
      }
      if (v.media) { montrerMedia(v.media); }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    options.forEach(function (fs) { fs.addEventListener('change', appliquer); });

    /* « Buy more, save more » : le palier choisi regle la quantite envoyee.
       La remise elle-meme est faite par Shopify dans le panier. */
    var quantite = fiche.querySelector('[data-pl-qty]');
    fiche.querySelectorAll('[data-pl-tier]').forEach(function (bouton, i, tous) {
      bouton.addEventListener('click', function () {
        tous.forEach(function (b) { b.setAttribute('aria-pressed', b === bouton ? 'true' : 'false'); });
        if (quantite) { quantite.value = bouton.getAttribute('data-pl-tier'); }
      });
    });

    /* Barre d'achat collante : visible quand le bouton principal sort de l'ecran */
    var colle = fiche.querySelector('[data-pl-sticky-buy]');
    var principalBtn = fiche.querySelector('[data-pl-submit]');
    if (colle && principalBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        var hors = !entrees[0].isIntersecting && entrees[0].boundingClientRect.top < 0;
        colle.classList.toggle('is-visible', hors);
        colle.setAttribute('aria-hidden', hors ? 'false' : 'true');
        var b = colle.querySelector('.pl-btn');
        if (b) { b.tabIndex = hors ? 0 : -1; }
      }).observe(principalBtn);
    }
  }

  /* ------------------------------------------------------------------
     Grand visuel (pl-hero) : video en boucle par-dessus l'image.
     La balise <video> arrive sans adresse ; ici on choisit UN fichier :
     portrait sous 750 px (meme seuil que le <picture>), paysage au-dessus,
     l'autre s'il n'y en a qu'un. Parmi les MP4 de Shopify, le plus petit
     qui couvre le cadre (ecran x densite, plafonnee a 2). Rien n'est
     charge si le visiteur demande moins d'animations ou economise ses
     donnees. Pause quand le visuel sort de l'ecran. Pas de changement de
     fichier si la fenetre change de taille (pas de double telechargement).
     ------------------------------------------------------------------ */
  function brancherVideoHero(racine) {
    racine.querySelectorAll('[data-pl-hero-video]').forEach(function (video) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      var reseau = navigator.connection;
      if (reseau && (reseau.saveData || /(^|-)2g$/.test(reseau.effectiveType || ''))) { return; }

      function lire(attr) {
        try { return JSON.parse(video.getAttribute(attr) || '[]'); } catch (e) { return []; }
      }
      var bureau = lire('data-desktop');
      var tel = lire('data-mobile');
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var liste = mobile ? (tel.length ? tel : bureau) : (bureau.length ? bureau : tel);
      if (!liste.length) { return; }

      /* Largeur affichee en pixels reels (object-fit: cover) */
      liste.sort(function (a, b) { return a.w - b.w; });
      var grand = liste[liste.length - 1];
      var choix = grand;
      if (grand.w && grand.h) {
        var boite = video.getBoundingClientRect();
        var densite = Math.min(window.devicePixelRatio || 1, 2);
        var besoin = Math.max(boite.width, boite.height * grand.w / grand.h) * densite;
        for (var i = 0; i < liste.length; i++) {
          if (liste[i].w >= besoin * 0.9) { choix = liste[i]; break; }
        }
      }

      /* Lecture auto refusee (iPhone en mode economie d'energie, batterie
         jaune) : Safari lit un MP4 pose dans une balise <img>, comme une
         image animee, que ce mode ne bloque pas. Ailleurs (Chrome n'accepte
         pas de MP4 en <img>) : la video demarre au premier toucher de
         l'ecran (un geste du visiteur autorise la lecture). */
      var enAttente = false;
      var image = null;
      var visible = !('IntersectionObserver' in window);
      function auPremierGeste() {
        if (enAttente) { return; }
        enAttente = true;
        function essayer() {
          document.removeEventListener('touchend', essayer);
          document.removeEventListener('click', essayer);
          enAttente = false;
          lancer();
        }
        document.addEventListener('touchend', essayer, { passive: true });
        document.addEventListener('click', essayer);
      }
      function refus() {
        if (document.hidden) { return; } /* relance au retour sur la page */
        if (image) { auPremierGeste(); return; }
        image = new Image();
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
        image.className = 'pl-hero__video';
        image.onload = function () {
          video.pause();
          video.parentNode.insertBefore(image, video.nextSibling);
          requestAnimationFrame(function () { image.classList.add('is-playing'); });
        };
        image.onerror = auPremierGeste;
        image.src = choix.url;
      }
      function lancer() {
        if (image && image.parentNode) { return; }
        var p = video.play();
        if (p && p.catch) { p.catch(refus); }
      }
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      video.muted = true;
      video.src = choix.url;

      /* Retour sur la page (autre onglet, autre appli, bouton retour) : le
         navigateur a mis la video en pause, on la relance. */
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && visible) { lancer(); }
      });
      window.addEventListener('pageshow', function () { if (visible) { lancer(); } });
      /* Filet de securite (Safari iOS fige parfois la video au retour sans
         la mettre en pause) : chaque seconde, si la video est a l'ecran mais
         arretee ou figee 2 s, on la relance. */
      var dernierT = -1;
      var figee = 0;
      setInterval(function () {
        if (!visible || document.hidden || (image && image.parentNode)) { return; }
        if (video.paused) { lancer(); return; }
        if (video.readyState >= 3 && video.currentTime === dernierT) {
          figee += 1;
          if (figee >= 2) { figee = 0; video.pause(); lancer(); }
        } else {
          figee = 0;
        }
        dernierT = video.currentTime;
      }, 1000);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entrees) {
          visible = entrees[0].isIntersecting;
          if (visible) { lancer(); } else { video.pause(); }
        }).observe(video);
      } else {
        lancer();
      }
    });
  }
  brancherVideoHero(document);
  /* Editeur de theme : la section est re-rendue a chaque reglage */
  document.addEventListener('shopify:section:load', function (e) { brancherVideoHero(e.target); });

  /* ------------------------------------------------------------------
     "Shop the room" : onglets par piece
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-pl-rooms]').forEach(function (bloc) {
    var onglets = Array.prototype.slice.call(bloc.querySelectorAll('[data-pl-room-tab]'));
    function activer(onglet) {
      onglets.forEach(function (o) {
        var actif = o === onglet;
        o.setAttribute('aria-selected', actif ? 'true' : 'false');
        var panneau = document.getElementById(o.getAttribute('aria-controls'));
        if (panneau) { panneau.hidden = !actif; }
      });
    }
    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () { activer(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') { return; }
        var suivant = onglets[(i + (e.key === 'ArrowRight' ? 1 : -1) + onglets.length) % onglets.length];
        activer(suivant);
        suivant.focus();
      });
    });
  });

  /* ------------------------------------------------------------------
     Page collection : une case cochee ou un tri choisi envoie le
     formulaire tout de suite. Un seul filtre ouvert a la fois.
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-pl-filters]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-pl-filter-auto')) { form.submit(); }
    });
    var filtres = Array.prototype.slice.call(form.querySelectorAll('.pl-filter'));
    filtres.forEach(function (f) {
      f.addEventListener('toggle', function () {
        if (f.open) { filtres.forEach(function (autre) { if (autre !== f) { autre.open = false; } }); }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pl-filter')) { filtres.forEach(function (f) { f.open = false; }); }
    });
  });

  /* ------------------------------------------------------------------
     Recommandations produit (calculees par Shopify)
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-pl-related]').forEach(function (zone) {
    var url = zone.getAttribute('data-url');
    if (!url) { return; }
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) { return; }
        var tampon = document.createElement('div');
        tampon.innerHTML = html;
        var neuf = tampon.querySelector('[data-pl-related]');
        if (neuf && neuf.querySelector('.pl-card')) {
          zone.innerHTML = neuf.innerHTML;
          brancherRails(zone);
        }
      })
      .catch(function () { /* on garde le rendu initial */ });
  });
})();
